import { atomWithReset } from "jotai/utils";

export const claimHistoryReviewModalAtom = atomWithReset<{
  visible: boolean;
  publicId: string | null;
  isViewDetail?: boolean;
}>({
  visible: false,
  publicId: null,
  isViewDetail: false
});
